import { render, staticRenderFns } from "./home-insurance-house-form.html?vue&type=template&id=20c2ee14&scoped=true&"
import script from "./home-insurance-house-form.js?vue&type=script&lang=js&"
export * from "./home-insurance-house-form.js?vue&type=script&lang=js&"
import style0 from "./home-insurance-house-form.scss?vue&type=style&index=0&id=20c2ee14&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c2ee14",
  null
  
)

export default component.exports